<template>
  <div class="notify-list">
    <div class="top">
      <div class="top-left">
        <img :src="notifyTypeList[item.noticeType].icon" alt="" />
        <span>{{ notifyTypeList[item.noticeType].name }}</span>
      </div>
      <div class="top-right">{{ item.createTime }}</div>
    </div>
    <div class="bottom">
      {{ item.noticeContent }}
    </div>
  </div>
</template>

<script>
import { notifyTypeList } from "@/utils/const.js";
export default {
  name: "NotifyList",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      notifyTypeList
    };
  },
  async mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.notify-list {
  padding: 15px 12px 17px 12px;
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 16px;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .top-left {
      display: flex;
      align-items: center;
      color: #333333;
      img {
        width: 18px;
        height: 18px;
        margin-right: 8px;
      }
    }
    .top-right {
      font-size: 12px;
      color: #333;
      height: 24px;
      line-height: 28px;
    }
  }
  .bottom {
    font-size: 12px;
    color: #333333;
    //设置文本超长省略号
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: 16px 0;
  }
}
</style>
